'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIFlex;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FlexConstants = require('./FlexConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var StyledFlex = _styledComponents2.default.div.withConfig({
  displayName: 'UIFlex__StyledFlex'
})(['display:flex;flex-grow:1;align-items:', ';align-self:', ';flex-direction:', ';justify-content:', ';flex-wrap:', ';max-width:100%;width:100%;'], function (props) {
  return _FlexConstants.ALIGN_OPTIONS[props.align];
}, function (props) {
  return _FlexConstants.ALIGN_SELF_OPTIONS[props.alignSelf];
}, function (props) {
  return _FlexConstants.DIRECTION_OPTIONS[props.direction];
}, function (props) {
  return _FlexConstants.JUSTIFY_OPTIONS[props.justify];
}, function (props) {
  return _FlexConstants.WRAP_OPTIONS[props.wrap];
});

function UIFlex(props) {
  var align = props.align,
      alignSelf = props.alignSelf,
      children = props.children,
      className = props.className,
      direction = props.direction,
      justify = props.justify,
      wrap = props.wrap,
      rest = _objectWithoutProperties(props, ['align', 'alignSelf', 'children', 'className', 'direction', 'justify', 'wrap']);

  return _react2.default.createElement(
    StyledFlex,
    _extends({}, rest, {
      align: align,
      alignSelf: alignSelf,
      className: (0, _classNames2.default)('private-flex', className),
      direction: direction,
      justify: justify,
      wrap: wrap
    }),
    children
  );
}

UIFlex.propTypes = {
  align: _react.PropTypes.oneOf(Object.keys(_FlexConstants.ALIGN_OPTIONS)),
  alignSelf: _react.PropTypes.oneOf(Object.keys(_FlexConstants.ALIGN_SELF_OPTIONS)),
  children: _react.PropTypes.node.isRequired,
  direction: _react.PropTypes.oneOf(Object.keys(_FlexConstants.DIRECTION_OPTIONS)),
  justify: _react.PropTypes.oneOf(Object.keys(_FlexConstants.JUSTIFY_OPTIONS)),
  wrap: _react.PropTypes.oneOf(Object.keys(_FlexConstants.WRAP_OPTIONS))
};

UIFlex.defaultProps = {
  align: 'start',
  direction: 'row',
  justify: 'start',
  wrap: 'nowrap'
};

UIFlex.displayName = 'UIFlex';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/layout/UIFlex.js
// module id = 120
// module chunks = 171